module.exports = __webpack_public_path__ + "img/0.dc4d9e0b.png";